import { Injectable } from '@angular/core';
import { LiveStreamSDK, LogLevel, SESSION_MODES, StreamSessionConfig, StreamMode } from '@rideview/livestream-web-sdk';
import { Subject } from 'rxjs';
import { API } from '@app-core/constants/api.constants';
import { AccessService } from '@app-core/services/access/access.service';
@Injectable({
  providedIn: 'root',
})
export class LiveStreamSdkService {
  private sdk: LiveStreamSDK;
  public connectionState$ = new Subject<string>();
  public error$ = new Subject<any>();
  public sessionConflict$ = new Subject<any>();

  constructor(private accessService: AccessService) {
    this.sdk = new LiveStreamSDK({
      mode: SESSION_MODES.SDK_MANAGED,
      apiBaseUrl: API.INTERMEDIATE_SERVER_URL,
      headers: {
        'X-Access-Token': this.accessService.getLoginInfo().token,
      },
      logLevel: LogLevel.ERROR,
      enableTelemetry: false,
    });

    this.sdk.on('connected', () => {
      this.connectionState$.next('connected');
    });
    this.sdk.on('playing', () => this.connectionState$.next('playing'));
    this.sdk.on('buffering', () => this.connectionState$.next('buffering'));
    this.sdk.on('device-connected', () => this.connectionState$.next('device-connected'));
    this.sdk.on('error', (err) => {
      console.error('Live Stream SDK Error:', { ...err });
      this.error$.next(err);
    });
  }

  async startStreaming(config: StreamSessionConfig, mode: StreamMode) {
    try {
      const res: any = await this.sdk.start(config, mode);
      return { ...res, streamRequestId: res.currentSessionId };
    } catch (err) {
      console.error('Error starting livestream:', { ...err });
      if (err?.cause?.data?.conflictingRequestId) {
        this.sessionConflict$.next({
          conflictingRequestId: err.cause.data.conflictingRequestId,
          config,
          mode,
        });
      } else {
        this.error$.next(err);
      }
      throw err;
    }
  }

  attach(videoElement: HTMLVideoElement) {
    this.sdk.attach(videoElement);
  }

  async stopStreaming() {
    try {
      await this.sdk.stop();
    } catch (err) {
      this.error$.next(err);
      throw err;
    }
  }
  async joinLivestream(conflictingRequestId: string, fleetId: string, mode: StreamMode) {
    try {
      const res: any = await this.sdk.join(conflictingRequestId, fleetId, mode);
      return { ...res, streamRequestId: res.currentSessionId };
    } catch (err) {
      this.error$.next(err);
      throw err;
    }
  }
}
